import { PplxError } from '#pplx/frontend/common/errors.js';
export class FetcherError extends PplxError {
    name = 'FetcherError';
    backendErrorCode;
    constructor(code, args = {}) {
        super(code, args);
        this.backendErrorCode = args.backendErrorCode;
    }
}
export const CF_CHALLENGE_403_CODES = new Set([
    'FETCHER_SSE_CLOUDFLARE_403_ERROR',
    'FETCHER_CLOUDFLARE_403_ERROR',
]);
export function getFetcherErrorCode(err) {
    if (err instanceof FetcherError)
        return err.code;
    if (err instanceof Error && err.cause)
        return getFetcherErrorCode(err.cause);
    return undefined;
}
export function getBackendErrorCode(err) {
    if (err instanceof FetcherError && err.backendErrorCode)
        return err.backendErrorCode;
    if (err instanceof Error && err.cause)
        return getBackendErrorCode(err.cause);
    return undefined;
}
export function isCfChallenge403Error(err) {
    const code = getFetcherErrorCode(err);
    return code !== undefined && CF_CHALLENGE_403_CODES.has(code);
}
//# sourceMappingURL=errors.js.map